var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"width"}},[(_vm.show)?_c('div',{staticClass:"audio-recording caption"},[_c('span',{staticClass:"audio-recording__text"},[_vm._v(_vm._s(_vm.durationText))])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }